import React from "react";
import SingleTestimonial from "../../components/Testimonial/SingleTestimonial";
import testiImg from "../../assets/images/testimonial/testimonial.png";
import comaImg from "../../assets/images/testimonial/coma.png";
import SectionTitle from "../../components/SectionTitle";
import Slider from "react-slick";
import { TESTIMONIALS_DATA } from "./testimonials-data";

const TestimonialsMain = () => {
  const testimonialSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enables automatic sliding
    autoplaySpeed: 3000, // Adjust time interval in milliseconds (3 seconds)
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="react-clients react-clientso home-testimonial pt---40 pb---60 ">
        <div className="container " style={{ marginBottom: "100px" }}>
          <SectionTitle Title="What our students saying" />
          <div
            className="client-slider wow animate__fadeInUp"
            data-wow-duration="0.3s"
          >
            <Slider {...testimonialSettings}>
              {TESTIMONIALS_DATA.map((testimonial) => (
                <SingleTestimonial
                  itemClass="single-client"
                  itemImg={testimonial.image}
                  Title={testimonial.name}
                  Designation={testimonial.description}
                  Desc={testimonial.review}
                  ratingCount="4.9"
                  reviewCount="14"
                  comaImg={comaImg}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialsMain;
